import { defineComponent as _defineComponent } from 'vue';
import { useYoutubeVideoID } from '~/composables/useYoutubeVideoID';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'YoutubeThumbnail',
  props: {
    videoUrl: {
      type: String,
      required: true
    }
  },
  emits: ['thumbnail-clicked'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var preparedSrc = computed(function () {
      var videoId = useYoutubeVideoID(props.videoUrl);
      return "https://i.ytimg.com/vi/".concat(videoId, "/hqdefault.jpg");
    });
    return {
      __sfc: true,
      props: props,
      preparedSrc: preparedSrc,
      emit: emit,
      AzIcon: AzIcon
    };
  }
});